module.exports = __webpack_public_path__ + "static/img/txt.4f52c563.png";